export default __webpack_public_path__ + "static/media/timemachine.4b5f231b.jpg";